import { receiverFactory } from './genericReceiverFactory';
const receivePostMessageFactory = receiverFactory(window);
export default receivePostMessageFactory;
